import {Component, Inject, OnInit} from '@angular/core';
import {DialogData} from '@Common/widgets/general/dialog-validation';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormModel, FormState} from '../../models';
import {UrlModel} from '../../../../services/url/url.model';
import {UrlService} from '../../../../services/url/url.service';
import {SubSink} from '@Common/core/utils/subsink';
import {finalize} from 'rxjs/operators';
import {StateValidationModel} from './state-validation.model';

/**
 * Formulaire publication
 * - draft => publié
 * - hors ligne n'ayant plus de lien => publié
 */
@Component({
  selector: 'app-state-validation',
  templateUrl: './state-validation.component.html',
  styleUrls: ['./state-validation.component.scss']
})
export class StateValidationComponent implements OnInit {
  form: FormModel;
  formState = FormState;
  dialogData: DialogData = new DialogData();
  saveDisabled = false;
  loading = false;
  subSink = new SubSink();
  constructor(@Inject(MAT_DIALOG_DATA) public data: FormModel,
              public dialogRef: MatDialogRef<StateValidationComponent>,
              private urlSvc: UrlService) {
    this.form = data;
  }

  ngOnInit(): void {
    this._checkAndCreateUrl();
  }
  private _checkAndCreateUrl() {
    if (! this.form.url_obj || this.form.url_obj.length < 1) {
      this.loading = true;
      const urlForm = <UrlModel> {
        id: 0,
        form: this.form.id, description: this.form.description
      };
      this.subSink.sink = this.urlSvc
        .updateOrcreate(urlForm)
        .pipe(finalize(() => this.loading = false))
        .subscribe(_url => {
          if (Array.isArray(_url)) {
            this.form.url_obj = [..._url];
          } else {
            this.form.url_obj = [{..._url}];
          }
        });
    }
  }
  save() {
    const stateValidation = <StateValidationModel> {
      validate: true,
      form: this.form
    };
    this.dialogRef.close(stateValidation);
  }
  close() {
    const stateValidation = <StateValidationModel> {
      validate: false,
      form: this.form
    };
    this.dialogRef.close(stateValidation);
  }
  getTitle() {
    switch (this.form.state) {
      case FormState.draft:
        return 'Publication du formulaire';
      case FormState.offline:
        return 'Mise en ligne du formulaire';
      case FormState.archived:
        return 'Réactivation du formulaire';
      case FormState.published:
        return 'Formulaire déjà publié';
    }
  }
  saveIsDisabled() {
    return this.saveDisabled || (!this.form.url_obj || this.form?.url_obj?.length < 1);
  }
  onLoaded(loaded) {
    setTimeout(() => this.saveDisabled = ! loaded);
  }
  onEditInPlace(editInPlace) {
    setTimeout(() => this.saveDisabled = editInPlace);
  }
}
